















import { Component, Vue, Prop } from 'vue-property-decorator';
import { menuModule } from '@/store/modules/menu';
import { mixins } from 'vue-class-component';
import { MenuMixins } from './MenuMixins';

@Component
export default class TemplateSelector extends mixins(MenuMixins) {
  @Prop({ required: true, type: String, default: '' })
  value: string | undefined;
  get templates() {
    return menuModule.templates;
  }
}
